export default {
    appName: "Prime-Vision Creatives",
    domain: process.env.NODE_ENV == 'production'? 'https://www.primevisioncreatives.com' : 'http://127.0.0.1:8000',
    localUserKey: "fkdocbhukanmrhbrugu"
}
